module.exports = __webpack_public_path__ + "static/img/5.c95daa7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/eng/5.png
// module id = oVB9
// module chunks = 0